export default __webpack_public_path__ + "static/media/link5.71e01878.svg";